export const STATE_SELECTION_KEY = 'lotto-club:selected-state:v1';

// Estimated 2026 top marginal rates for jackpot-size lottery winnings.
// Local taxes are excluded. California and Delaware lottery prizes are exempt.
export const US_STATES = [
  { code: 'AL', name: 'Alabama', rate: 0.05 },
  { code: 'AK', name: 'Alaska', rate: 0 },
  { code: 'AZ', name: 'Arizona', rate: 0.025 },
  { code: 'AR', name: 'Arkansas', rate: 0.039 },
  { code: 'CA', name: 'California', rate: 0 },
  { code: 'CO', name: 'Colorado', rate: 0.044 },
  { code: 'CT', name: 'Connecticut', rate: 0.0699 },
  { code: 'DE', name: 'Delaware', rate: 0 },
  { code: 'FL', name: 'Florida', rate: 0 },
  { code: 'GA', name: 'Georgia', rate: 0.0519 },
  { code: 'HI', name: 'Hawaii', rate: 0.11 },
  { code: 'ID', name: 'Idaho', rate: 0.053 },
  { code: 'IL', name: 'Illinois', rate: 0.0495 },
  { code: 'IN', name: 'Indiana', rate: 0.0295 },
  { code: 'IA', name: 'Iowa', rate: 0.038 },
  { code: 'KS', name: 'Kansas', rate: 0.0558 },
  { code: 'KY', name: 'Kentucky', rate: 0.035 },
  { code: 'LA', name: 'Louisiana', rate: 0.03 },
  { code: 'ME', name: 'Maine', rate: 0.0715 },
  { code: 'MD', name: 'Maryland', rate: 0.065 },
  { code: 'MA', name: 'Massachusetts', rate: 0.09 },
  { code: 'MI', name: 'Michigan', rate: 0.0425 },
  { code: 'MN', name: 'Minnesota', rate: 0.0985 },
  { code: 'MS', name: 'Mississippi', rate: 0.04 },
  { code: 'MO', name: 'Missouri', rate: 0.047 },
  { code: 'MT', name: 'Montana', rate: 0.0565 },
  { code: 'NE', name: 'Nebraska', rate: 0.0455 },
  { code: 'NV', name: 'Nevada', rate: 0 },
  { code: 'NH', name: 'New Hampshire', rate: 0 },
  { code: 'NJ', name: 'New Jersey', rate: 0.1075 },
  { code: 'NM', name: 'New Mexico', rate: 0.059 },
  { code: 'NY', name: 'New York', rate: 0.109 },
  { code: 'NC', name: 'North Carolina', rate: 0.0399 },
  { code: 'ND', name: 'North Dakota', rate: 0.025 },
  { code: 'OH', name: 'Ohio', rate: 0.0275 },
  { code: 'OK', name: 'Oklahoma', rate: 0.045 },
  { code: 'OR', name: 'Oregon', rate: 0.099 },
  { code: 'PA', name: 'Pennsylvania', rate: 0.0307 },
  { code: 'RI', name: 'Rhode Island', rate: 0.0599 },
  { code: 'SC', name: 'South Carolina', rate: 0.06 },
  { code: 'SD', name: 'South Dakota', rate: 0 },
  { code: 'TN', name: 'Tennessee', rate: 0 },
  { code: 'TX', name: 'Texas', rate: 0 },
  { code: 'UT', name: 'Utah', rate: 0.045 },
  { code: 'VT', name: 'Vermont', rate: 0.0875 },
  { code: 'VA', name: 'Virginia', rate: 0.0575 },
  { code: 'WA', name: 'Washington', rate: 0 },
  { code: 'WV', name: 'West Virginia', rate: 0.0482 },
  { code: 'WI', name: 'Wisconsin', rate: 0.0765 },
  { code: 'WY', name: 'Wyoming', rate: 0 },
  { code: 'DC', name: 'Washington, D.C.', rate: 0.1075 }
];

export function isStateCode(value) {
  return US_STATES.some((state) => state.code === value);
}

export function estimateStateTakeHome(cashValue, federalTax, stateCode) {
  if (!Number.isFinite(cashValue) || !Number.isFinite(federalTax)) {
    return null;
  }
  const state = US_STATES.find((item) => item.code === stateCode);
  if (!state) {
    return null;
  }
  const stateTax = Math.round(cashValue * state.rate);
  return Math.max(0, cashValue - federalTax - stateTax);
}
